module.exports = __webpack_public_path__ + "img/social_icon_pintrest.f940eac9.png";